<template>
  <div class="mt-2rem mb-10rem">
    <section class="mb-5rem">
      <v-container>
        <v-row justify="center" class="text-center">
          <v-col cols="12" sm="8" md="6">
            <h1 class="display-3 font-weight-black mb-10">JINDO <br> COIN WOW 🐕</h1>
            <p>
              Loyal and best friend, Jindo is always by your side. Coming from South Korea and if you cuddle him,
              he will not be available to contain his happiness. Always is a best friend!
              Some day everybody will have one $JINDO - A small puppy with a cute face.
              Collect all the Jindos to be friendly and happy as Jindo.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="mb-5rem">
      <v-container>
        <v-row justify="center" class="mb-10">
          <v-col cols="12" sm="6" md="4">
            <v-img
              class="rounded-xl"
              :src="require(`@/assets/collectible/jindocoin_wow_cover.jpg`)"
              :lazy-src="require(`@/assets/collectible/jindocoin_wow_cover.jpg`)">
            </v-img>
          </v-col>
          <v-col cols="12" justify="center" class="text-center">
            <div class="d-flex flex-column mb-10">
              <div>Name: <b class="ml-2">Jindo Coin Wow</b></div>
              <div>Artist Name: <b class="ml-2">Jindo Coin</b></div>
              <div>Size: <b class="ml-2">2000x2000</b></div>
              <div>Tier: <b class="ml-2">Common</b></div>
              <div>Copies: <b class="ml-2">75,000</b></div>
            </div>
            <v-btn
              @click="onClickDownload"
              rounded color="primary"
              class="black--text"
              x-large>
              Download
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    async onClickDownload () {
      const name = 'jindocoin_wow_nft.mp4'
      const url = require('@/assets/collectible/files/jindocoin_wow_nft.mp4')
      try {
        const resp = await this.$axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        })
        console.log(resp)
        this.forceFileDownload(resp, name)
      } catch (err) {
        console.log(err)
      }
    },
    forceFileDownload (resp, name) {
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
    }
  }
}
</script>
